import { Injectable } from '@angular/core';
import { UserDataService, UserProfile } from '@ddt-web/user-data';
import * as get from 'lodash/get';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CUSTOM_FEATURE_FIRM_DOMAIN_CONFIG, EmailDomainCustomizationFlags } from '../config/email-domain.config';

@Injectable()
export class EmailDomainCustomizationService {
	constructor(private userDataService: UserDataService) { }

	/**
	 * Returns a boolean observable that represents whether the current user 
	 * belongs to the passed firm (email domain)
	 */
	public isUserFromFirm(firmName: string): Observable<boolean> {
		return this.userDataService.getUserProfile().pipe(
			map((userProfile: UserProfile) => {
				return firmName === userProfile?.emailDomain?.toLowerCase();
			})
		);
	}

	/**
	 * Returns a boolean observable that represents whether the customization feature passed 
	 * is applicable for the current user based on email domain
	 */
	public isFeatureEnabledOnFirm(feature: EmailDomainCustomizationFlags): Observable<boolean> {
		return this.userDataService.getUserProfile().pipe(
			map((userProfile: UserProfile) => {
				const featureFirmsList = get(CUSTOM_FEATURE_FIRM_DOMAIN_CONFIG, feature, []);
				return featureFirmsList.includes(userProfile?.emailDomain?.toLowerCase());
			})
		);
	}
}
